import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.background};
  height: auto;
  padding: 48px 87px;
  font-size: 16px;

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    padding: 24px 16px;
    font-size: 12px;
  }

  flex-direction: row;
  flex-wrap: wrap;
  gap: 12%;
`;

export const TitleGroup = styled.h1`
  text-transform: capitalize;
  font-size: 36px;
  font-weight: bolder;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  justify-content: start
  width: 100%;
  gap: 16px;
  margin-bottom: 1rem;
`;

export const SubtitleGroup = styled.span`
  color: ${(props) => props.theme.colors.label};
`;

export const DescriptionGroup = styled.p`
  color: ${(props) => props.theme.colors.body};
  text-align: inherit;
`;

export const InformationsGroup = styled.div`
  flex: 1;
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
  text-align: start;

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    align-items: center;
    text-align: justify;
    margin-bottom: 24px;
  }
`;

export const InformationsSubscription = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  
  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    flex-direction: row;
    width: 100%;
    gap: 1.5rem;
  }
`;

export const TicketPriceGroup = styled.b`
  color: ${(props) => props.theme.colors.placeholder};
  font-size: 12px;
  font-weight: 700;
  margin-top: 16px;

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    margin-top: 0px;
  }
`;

export const Dot = styled.div`
  align-self: center;
  height: 4px;
  width: 4px;
  background-color: ${(props) => props.theme.colors.label};
  border-radius: 50%;
`;

export const LottieContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px;

  div{
    display: flex !important;
    align-items: center !important;
    width: 400px !important;
    height: 400px !important;

    ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
      height: 200px !important;
      width: 200px !important;
    }
    
  }
`;

export const TextLottie = styled.span`
  font-size: 20px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.label};
  margin-bottom: 20px;
`;

export const Banner = styled.img`
  width: 100%;
  height: 350px;
  align: center;
  object-fit: cover;
`;